<p-inputGroup>
    <input pInputText type="url" [attr.data-testid]="dataTestId()" [formControl]="formControl" />
    <p-button [icon]="props.icon" [disabled]="!formControl?.value" (onClick)="btnClick($event)" />
</p-inputGroup>
